(() => {
  const roots = document.querySelectorAll('[data-noir-dandadan-bundle]');
  if (!roots.length) return;

  const readData = (root) => {
    const node = root.querySelector('[data-bundle-data]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (error) {
      console.error('Dan Da Dan bundle data could not be read.', error);
      return null;
    }
  };

  const findComponentVariant = (variants, wantedOptions) =>
    variants.find(
      (variant) =>
        variant.options.length === wantedOptions.length &&
        variant.options.every((value, index) => value === wantedOptions[index])
    );

  const findBundleVariant = (bundle, state) =>
    bundle?.variants.find(
      (variant) =>
        variant.options[0] === state.mouse &&
        variant.options[1] === state.keychain &&
        variant.options[2] === state.mousepad
    );

  const formatPrice = (amount, locale, currency) =>
    new Intl.NumberFormat(locale || 'id-ID', {
      style: 'currency',
      currency: currency || 'IDR',
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount / 100);

  roots.forEach((root) => {
    const data = readData(root);
    if (!data || !Array.isArray(data.bundles)) return;

    const form = root.querySelector('form[data-type="add-to-cart-form"]');
    const variantInput = form?.querySelector('[name="id"]');
    const submitButton = form?.querySelector('[type="submit"]');
    const status = root.querySelector('[data-bundle-status]');
    const regularPrice = root.querySelector('[data-regular-price]');
    const bundlePrice = root.querySelector('[data-bundle-price]');
    const previewNote = root.querySelector('[data-bundle-preview-note]');
    const previewSimulation =
      window.Shopify?.designMode === true &&
      new URLSearchParams(window.location.search).get('bundle-preview') === 'simulate';
    const buyNow = form.querySelector('[data-bundle-buy-now]');
    if (!form || !variantInput || !submitButton || !regularPrice || !bundlePrice) return;

    const readState = () => {
      const state = {};
      root.querySelectorAll('[data-bundle-choice]:checked').forEach((input) => {
        state[input.dataset.bundleChoice] = input.value;
      });
      return state;
    };

    const getBundle = (state) =>
      data.bundles.find(
        (bundle) =>
          bundle.productId &&
          bundle.keyboardCharacter === state.keyboardCharacter &&
          bundle.switchType === state.switchType
      );

    const getTotalRegularPrice = (state) => {
      const keyboard = findComponentVariant(data.components.keyboard, [
        state.keyboardCharacter,
        state.switchType,
      ]);
      const mouse = findComponentVariant(data.components.mouse, [state.mouse]);
      const keychain = findComponentVariant(data.components.keychain, [state.keychain]);
      const mousepad = findComponentVariant(data.components.mousepad, [state.mousepad]);
      const components = [keyboard, mouse, keychain, mousepad];
      if (components.some((variant) => !variant || variant.price == null)) return null;
      return components.reduce((total, variant) => total + Number(variant.price), 0);
    };

    const variantIsAvailable = (state) => {
      const bundle = getBundle(state);
      const variant = findBundleVariant(bundle, state);
      return Boolean(variant?.available);
    };

    const updatePrice = (state) => {
      const total = getTotalRegularPrice(state);
      if (total == null) return;
      const label = regularPrice.querySelector('s');
      if (label) label.textContent = formatPrice(total, data.locale, data.currency);
    };

    const updateChoices = (state) => {
      root.querySelectorAll('[data-bundle-choice]').forEach((input) => {
        const candidateState = { ...state, [input.dataset.bundleChoice]: input.value };
        const unavailable = !variantIsAvailable(candidateState);
        input.disabled = !previewSimulation && unavailable;
        input.closest('.noir-dandadan-bundle__choice')?.setAttribute(
          'aria-disabled',
          !previewSimulation && unavailable ? 'true' : 'false'
        );
      });
    };

    const sync = () => {
      const state = readState();
      const bundle = getBundle(state);
      const variant = findBundleVariant(bundle, state);
      const available = Boolean(bundle && variant?.available);

      updateChoices(state);
      updatePrice(state);

      if (previewSimulation) {
        variantInput.disabled = true;
        submitButton.disabled = true;
        submitButton.setAttribute('aria-disabled', 'true');
        if (buyNow) buyNow.hidden = true;
        if (status) status.hidden = true;
        if (previewNote) previewNote.hidden = false;
        return;
      }

      if (previewNote) previewNote.hidden = true;

      if (available) {
        const changed = variantInput.value !== String(variant.id);
        variantInput.value = variant.id;
        variantInput.disabled = false;
        if (changed) variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        submitButton.disabled = false;
        submitButton.removeAttribute('aria-disabled');
        if (buyNow) buyNow.hidden = false;
        if (status) status.hidden = true;
      } else {
        variantInput.disabled = true;
        submitButton.disabled = true;
        submitButton.setAttribute('aria-disabled', 'true');
        if (buyNow) buyNow.hidden = true;
        if (status) {
          status.textContent = root.dataset.unavailableMessage || '';
          status.hidden = false;
        }
      }
    };

    root.addEventListener('change', (event) => {
      if (event.target.matches('[data-bundle-choice]')) sync();
    });

    form.addEventListener('submit', (event) => {
      const state = readState();
      if (previewSimulation || !variantIsAvailable(state)) {
        event.preventDefault();
        sync();
      }
    });

    sync();
  });
})();
